import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=4ac54d1b&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=ts&"
export * from "./Mask.vue?vue&type=script&lang=ts&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=4ac54d1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac54d1b",
  null
  
)

export default component.exports